import { useLocation, useNavigate, useMatch } from 'react-router-dom';

const withRouter = (Component) => {
  const Wrapper = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const match = useMatch(`*`);
    return (
      <Component
        navigate={navigate}
        location={location}
        match={{
          ...match,
          path: location.pathname,
          url: location.pathname,
          params: match?.params || {},
        }}
        {...props}
      />
    );
  };
  return Wrapper;
};

export default withRouter;
